import { TableCellProps } from "react-virtualized";

export function cellRenderer({ cellData }: TableCellProps) {
  if (cellData == null) {
    return "";
  } else {
    return cellData;
  }
}
